module.exports = __webpack_public_path__ + "static/Affiliate-5a8cb462ee38f7ccacfd12597af1a9cd.svg";